import { render, staticRenderFns } from "./EstrategiasFoda.vue?vue&type=template&id=2de8d327&"
import script from "./EstrategiasFoda.vue?vue&type=script&lang=js&"
export * from "./EstrategiasFoda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports